import { render, staticRenderFns } from "./FileStatus.vue?vue&type=template&id=495be20b&scoped=true&"
import script from "./FileStatus.vue?vue&type=script&lang=js&"
export * from "./FileStatus.vue?vue&type=script&lang=js&"
import style0 from "./FileStatus.vue?vue&type=style&index=0&id=495be20b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495be20b",
  null
  
)

export default component.exports